// test1804
(1804 && 0);
